__turbopack_context__.v({
  "center": "StyledAllInclusiveAlert-module___B-7dG__center",
  "container": "StyledAllInclusiveAlert-module___B-7dG__container",
  "dataContainer": "StyledAllInclusiveAlert-module___B-7dG__dataContainer",
  "donationsTotal": "StyledAllInclusiveAlert-module___B-7dG__donationsTotal",
  "heading": "StyledAllInclusiveAlert-module___B-7dG__heading",
  "innerContainer": "StyledAllInclusiveAlert-module___B-7dG__innerContainer",
  "left": "StyledAllInclusiveAlert-module___B-7dG__left",
  "pixel": "StyledAllInclusiveAlert-module___B-7dG__pixel",
  "pride": "StyledAllInclusiveAlert-module___B-7dG__pride",
  "right": "StyledAllInclusiveAlert-module___B-7dG__right",
  "sakura": "StyledAllInclusiveAlert-module___B-7dG__sakura",
  "standard": "StyledAllInclusiveAlert-module___B-7dG__standard",
});
